export default __webpack_public_path__ + "static/media/studentModalTestSeries.47caf805.svg";